import React from "react";

const Footer = () => {
  return (
    <footer className="d-block d-lg-none text-center">
      &copy; Copyright, the product, all rights reserved
    </footer>
  );
};

export default Footer;
